import React, { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useActiveEstId } from './AuthContext';
import './EstablishmentCard.css';

/**
 * Shared establishment selector.
 * For ClientAdmin/MultiClientAdmin: auto-selects the locked/active org, hides the picker.
 * For SuperAdmin: renders the full org picker.
 *
 * Props:
 *   establishments – array of { id, name, code? }
 *   value          – currently selected id (string)
 *   onChange       – standard React change event handler (receives e with e.target.value)
 *   loading        – boolean
 */
export default function EstablishmentCard({ establishments = [], value, onChange, loading, style }) {
  const lockedEstId = useActiveEstId();

  // For ClientAdmin: auto-select their org and skip the dropdown entirely
  useEffect(() => {
    if (lockedEstId && onChange) {
      onChange({ target: { value: lockedEstId } });
    }
  }, [lockedEstId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (lockedEstId) return null;

  return (
    <div className="est-card-wrap" style={style}>
      <label className="est-label">Organization</label>
      <div className="est-dropdown">
        <select
          value={value}
          onChange={onChange}
          className="est-select"
          disabled={loading}
        >
          {loading ? (
            <option value="">Loading organizations...</option>
          ) : establishments.length === 0 ? (
            <option value="">No organizations found</option>
          ) : (
            <>
              <option value="">Select organization</option>
              {establishments.map((est) => (
                <option key={est.id} value={est.id}>
                  {est.name}{est.code ? ` (${est.code})` : ''}
                </option>
              ))}
            </>
          )}
        </select>
        <ChevronDown className="est-chevron" size={16} />
      </div>
    </div>
  );
}
